import React, { useEffect, useState } from 'react'
import { isValidPhoneNumber } from 'libphonenumber-js'
import {
  AskMeLaterBtn,
  FlexAlignCenter,
  PhoneInputError,
  PhoneInputPlaceHolder,
  WhatsappHeading,
  WhatsappHeadingDesc,
} from './style'
import WhatsappIcon from '../../../components/Images/WhatsappIcon'
import { PhoneInput } from '../../../components/FormComponents'
import { Popup } from '../../../components/Popup'
import WhatsAppSuccessPopUp from './WhatsAppSuccessPopUp'
import { post } from '../../../lib/api'
import Loader from '../../../components/Loader'

export default function WhatsAppPopUp({phone_number}) {
  const [inputDisabled, setInputDisabled] = useState(false)
  const [formError, setFormError] = useState(null)
  const [phone, setPhone] = useState('');
  const [showPopUp, updatePopUp] = useState(true)
  const [successPopUp,setSuccessPopUp] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handlePhoneInputChange = (text) => {
    setFormError(null)
    setPhone(text);
  }

  const handleAskMeLater = () => {
    updatePopUp(false)
    post('/user_api/user.update?is_novel=1',{
      data: {
        is_writer_whatsapp: 0,
        phone_number: `+${phone}`,
      }
    })
  }

  const handleSubscribe = () => {
    if(!isValidPhoneNumber(`+${phone}`)){
      setFormError('Please enter the valid number')
      return
    }
    if(isLoading) return
    setIsLoading(true)
    post('/user_api/user.update?is_novel=1',{
      data: {
        is_writer_whatsapp: 1,
        phone_number: `+${phone}`,
      }
    }).then(() => {
      setSuccessPopUp(true)
      updatePopUp(false)
      setIsLoading(false)
    }).catch(() => {
      setFormError('Sorry, we are facing some issues, try again later.')
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if(phone_number && phone_number.length > 1){
      setInputDisabled(true)
      phone_number[0] === '+' ? setPhone(phone_number.slice(1) || '') : setPhone(phone_number || '')
    }
  },[phone_number])

  return (
    <>
      <WhatsAppSuccessPopUp show={successPopUp} />
      <Popup
        show={showPopUp}
        renderActions={
          <>
            <AskMeLaterBtn
              className="action-button primary"
              type="button"
              onClick={handleAskMeLater}
            >
              Ask Me Later
            </AskMeLaterBtn>
            <button
              className="action-button primary-button"
              type="button"
              onClick={handleSubscribe}
            >
              {isLoading ? <Loader invertColor noPadding size="md" /> : 'Subscribe'}
            </button>
          </>
        }
      >
        <FlexAlignCenter>
          <WhatsappIcon />
          <WhatsappHeading>Updates Over WhatsApp</WhatsappHeading>
        </FlexAlignCenter>
        <WhatsappHeadingDesc>
          Do you want to receive important information and updates over WhatsApp
        </WhatsappHeadingDesc>
        <PhoneInputPlaceHolder>Please enter your phone number</PhoneInputPlaceHolder>
        <PhoneInput
          error={formError}
          type="text"
          value={phone}
          onChange={handlePhoneInputChange}
          disabled={inputDisabled}
        />
        {formError && <PhoneInputError>{formError}</PhoneInputError>}
      </Popup>
    </>
  )
}
